import * as React from "react";
import { ppq } from "@teamprevent/common";
import { useSelector } from "react-redux";
import { useDispatch } from "@teamprevent/customer-redux";

import { ApplicationState } from "../../applicationState";
import { loadPpqReport } from "../actions";

export const PpqReport = () => {
    const dispatch = useDispatch();
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const viewReportTaskId = useSelector((state: ApplicationState) => state.router.params?.viewReportTaskId);
    const ppqReport = useSelector((state: ApplicationState) => state.ppqReports.find(r => r.viewTaskId === viewReportTaskId));

    React.useEffect(() => {
        dispatch(loadPpqReport({ ohCaseId, viewReportTaskId }));
    }, [dispatch, ohCaseId, viewReportTaskId]);

    if (!ppqReport) {
        return null;
    }

    return <ppq.PpqReport {...ppqReport} />;
};
